/* eslint-disable react-hooks/exhaustive-deps */
import { ApartmentOutlined, UnorderedListOutlined } from '@ant-design/icons';
import {
  Button,
  Checkbox,
  Empty,
  Layout,
  Modal,
  Pagination,
  Row,
  Select,
  Tabs,
  Tooltip,
} from 'antd';
import Axios from 'axios';
import { default as classNames, default as clsx } from 'classnames';
import _, { cloneDeep, set } from 'lodash';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import IconSize65On from '../../assets/icons/5-active.svg';
import IconSize65Off from '../../assets/icons/5-noactive.svg';
import IconSize66On from '../../assets/icons/6-active.svg';
import IconSize66Off from '../../assets/icons/6-noactive.svg';
import IconCameraEmpty from '../../assets/icons/camera-empty.svg';
import IconFullScreen from '../../assets/icons/fullscreen.svg';
import IconSize16Off from '../../assets/icons/size_16_off.svg';
import IconSize16On from '../../assets/icons/size_16_on.svg';
import IconSize4Off from '../../assets/icons/size_4_off.svg';
import IconSize4On from '../../assets/icons/size_4_on.svg';
import IconSize9Off from '../../assets/icons/size_9_off.svg';
import IconSize9On from '../../assets/icons/size_9_on.svg';
import AIView from '../../assets/icons/ai-view.svg';
import AutoPlayOff from '../../assets/icons/auto-play-off.svg';
import AutoPlayOn from '../../assets/icons/auto-play-on.svg';
import { DialPad } from '../../components/DialPad/DialPad';
import Spinner from '../../components/Spinner';
import ViewStreamComponent from '../../components/VideoStream/v2';
import * as SERVICE from '../../constants/service.types';
import * as SYSTEM from '../../constants/system.keys';
import {
  NOTIFIES,
  PINNED_CAMERAS,
  VIEW_STREAM_SERVICE_EXTEND,
  ZOOM_STATE,
} from '../../constants/system.keys';
import {
  changeDialPadData,
  clearAlert,
  openMessage,
  setCameraSerials,
  socketEmitEvent,
  toggleSmartMode,
} from '../../redux/actions';
import CameraSearch from '../Camera/CameraSearch';
import TreeCamera from '../Camera/TreeCamera/TreeCamera';
import DndPinCamera from './DndPinCamera';
import PinnedCameraComponent from './PinnedCamera';
import './index.scss';
import {
  getEventsByPersonId,
  getHistoryTrackingEvents,
  getSecurityIdentifications,
  getVirtualWall,
  getWeaponDetection,
} from '../../api/criticalApi';
import moment from 'moment';
import useElementDimensions from '../../hooks/useElementDimensions';
import storageService from '../../services/storage.service';
import AlertBox from './AlertBox';
import { useHistory } from 'react-router-dom';
import { LiveTree } from '../../components/Tree/Live/v2';
import { RECENT_GROUP_ID, ROOT_GROUP_ID } from '../../constants/group';
import { nextRequestId } from '../../socket/query';
import { useGateways } from '../../hooks/use-gateway-state';
import { useRecentCameras } from '../../hooks/use-recent-cameras';
import { ListCamera } from '../../components/Tree/Live/ListCamera';
import { CUSTOM_GROUP_ID } from '../../components/Tree/Live/constant';
import MilestoneVideoStreamComponent from '../../components/VideoStream/MilestoneVideoStream';
import { CAMERA_TYPE } from '../../constants';
import { beeXLogger } from '../../helpers/logger';
import { preloadCodecs } from '../../components/VideoStream/adapter/rtc-codec';
import {
  resetRecoveryLivePage,
  updateRecoveryLivePage,
} from '../../redux/recovery/action';
import { getRecoveryLivePage } from '../../redux/recovery/reducer';

const { Sider } = Layout;
const { Option } = Select;

const sortByName = (a, b) => {
  if (a?.name < b?.name) {
    return -1;
  }

  if (a?.name > b?.name) {
    return 1;
  }

  return 0;
};

const paginate = (data, page, size) => {
  return data.slice((page - 1) * size, page * size);
};

const makeRecentItemKey = (userId, namespace) => {
  return `recent-live-items-${userId}-${namespace}`;
};

const getLocalRecentItems = (userId, namespace) => {
  try {
    return JSON.parse(
      localStorage.getItem(makeRecentItemKey(userId, namespace)) || '[]',
    );
  } catch (error) {
    return [];
  }
};

const setLocalRecentItems = (userId, namespace, items) => {
  localStorage.setItem(
    makeRecentItemKey(userId, namespace),
    JSON.stringify(items),
  );
};

const mergeCameras = (camToDisplay, alertCams) => {
  const result = [];

  camToDisplay.forEach((cam, index) => {
    if (alertCams[index]) {
      result[index] = alertCams[index];
    } else {
      result[index] = cam;
    }
  });

  alertCams.forEach((cam, index) => {
    if (!result[index]) {
      result[index] = cam;
    }
  });

  return result;
};

const LivePage = () => {
  const {
    isAuth,
    userId,
    gatewayStates,
    cameraStates,
    namespace,
    dataUser,
    sipAccount,
    dialPad,
    isShowCritical,
    detectionAlerts,
    cameras,
    enabledSmartMode,
    listDeviceByGroupId,
    deviceContactInfo,
  } = useSelector((state) => state);
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isViewAll, setIsViewAll] = useState(
    () => localStorage.getItem('auto_play') === 'on',
  );
  const [isFullscreen, setFullScreen] = useState(false);
  const [modalEnableSmartModeVisible, setModalEnableSmartModeVisible] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const showModalEnableSmartMode = useRef(null);

  useEffect(() => {
    preloadCodecs('live');
  }, []);

  const REDUCE_DIMENSIONS = 5;
  const [selectedGroup, setSelectedGroup] = useState({
    id: RECENT_GROUP_ID,
    name: 'Pinned',
  });

  const selectedGroupId = selectedGroup?.id;

  const requestIdRef = useRef(null);
  const [recentItems, setRecentItems] = useState([]);

  const recentCamerasRaw = useMemo(() => {
    return recentItems
      .filter((item) => item.type === 'camera')
      .map((item) => item.data);
  }, [recentItems]);

  const { cameras: recentCameras, loading } = useRecentCameras({
    cameras: recentCamerasRaw,
    namespace,
    enabled: selectedGroupId === RECENT_GROUP_ID,
  });

  const finalLoading = isLoading || loading;

  useEffect(() => {
    setRecentItems(getLocalRecentItems(userId, namespace));
  }, [userId, namespace]);

  useEffect(() => {
    if (!userId || !namespace) {
      return;
    }

    setLocalRecentItems(userId, namespace, recentItems);
  }, [recentItems, userId, namespace]);

  const [pagination, setPagination] = useState({
    page: 1,
    size: 9,
    quality: ZOOM_STATE.THREE,
    grid: [3, 3],
  });
  const [selectCamera, setSelectCamera] = useState();
  const [customCamera, setCustomCamera] = useState();
  const [autoSwitchPageSeconds, setAutoSwitchPageSeconds] = useState(0);
  const [fullscreenCameraSerial, setFullscreenCameraSerial] = useState(null);
  const [pendingPage, setPendingPage] = useState(null);
  const {
    sidebarMode,
    selectedGroup: recoveryGroup,
    pagination: recoveryPagination,
    autoSwitchPageSeconds: recoveryAutoSwitchPageSeconds,
    selectedCamera: recoverySelectedCamera,
  } = useSelector(getRecoveryLivePage);
  const [searchResult, setSearchResult] = useState([]);

  /**
   * If selectedGroupId is ROOT_GROUP_ID, dataAllCamera is all camera
   */
  const [dataAllCamera, setDataAllCamera] = useState();
  /**
   * If selectedGroupId is not ROOT_GROUP_ID, RECENT_GROUP_ID
   */
  const [dataGroup, setDataGroup] = useState();

  const allCameras = useMemo(() => {
    if (customCamera) {
      // beeXLogger.debug('LivePage - customCamera: ', customCamera);
      return [customCamera];
    }

    if (selectedGroupId === ROOT_GROUP_ID) {
      // beeXLogger.debug('LivePage - ROOT_GROUP_ID: ', dataAllCamera);
      return dataAllCamera?.data || [];
    }

    if (selectedGroupId === RECENT_GROUP_ID) {
      // beeXLogger.debug('LivePage - RECENT_GROUP_ID: ', dataAllCamera);
      return recentCameras;
    }
    // beeXLogger.debug('LivePage - dataGroup: ', dataGroup);
    return dataGroup?.cameraInfos || [];
  }, [dataAllCamera, dataGroup, selectedGroupId, recentCameras, customCamera]);

  const camerasToDisplayUnsorted = useMemo(() => {
    if (searchResult) {
      // console.log('🚀 ~ LivePage ~ searchResult:', searchResult);
      return paginate(searchResult, pagination?.page, pagination?.size);
    }
    if (customCamera) {
      return [customCamera];
    }

    if (selectedGroupId === ROOT_GROUP_ID) {
      // beeXLogger.debug('LivePage - dataAllCamera', dataAllCamera);
      return dataAllCamera?.data || [];
    }

    if (selectedGroupId === RECENT_GROUP_ID) {
      // beeXLogger.debug('LivePage - recentCameras:', recentCameras);
      return paginate(recentCameras, pagination?.page, pagination?.size);
    }

    // beeXLogger.debug('LivePage - dataGroup:', dataGroup?.cameraInfos);
    return paginate(
      dataGroup?.cameraInfos || [],
      pagination?.page,
      pagination?.size,
    );
  }, [
    searchResult,
    dataAllCamera,
    dataGroup,
    selectedGroupId,
    recentCameras,
    pagination?.page,
    pagination?.size,
    customCamera,
  ]);

  const camerasToDisplay = useMemo(() => {
    return camerasToDisplayUnsorted;
  }, [camerasToDisplayUnsorted]);

  const total = useMemo(() => {
    if (selectedGroupId === ROOT_GROUP_ID) {
      // beeXLogger.debug('LivePage - dataAllCamera: ', dataAllCamera);
      return dataAllCamera?.totalSize || 0;
    }

    if (selectedGroupId === RECENT_GROUP_ID) {
      // beeXLogger.debug('LivePage - recentCameras: ', recentCameras);
      return recentCameras.length;
    }

    return dataGroup?.cameraInfos?.length || 0;
  }, [dataAllCamera, dataGroup, selectedGroupId, recentCameras]);

  useEffect(() => {
    setPagination((state) => ({
      ...state,
      page: 1,
      total,
      totalPage: Math.ceil(total / state.size),
      ...(recoveryPagination ? recoveryPagination : {}),
    }));
  }, [selectedGroupId, total]);

  useEffect(() => {
    if (!cameras) {
      return;
    }

    if (cameras.requestId === requestIdRef.current) {
      setDataAllCamera(cameras);
      setIsLoading(false);
    }
  }, [cameras]);

  useEffect(() => {
    if (
      listDeviceByGroupId &&
      listDeviceByGroupId.requestId === requestIdRef.current
    ) {
      setDataGroup(listDeviceByGroupId);
      setIsLoading(false);
    }
  }, [listDeviceByGroupId]);

  const handleFullScreen = useFullScreenHandle();

  const { dimensions, ref } = useElementDimensions(camerasToDisplay);

  useEffect(() => {
    if (selectedGroupId !== ROOT_GROUP_ID || !isAuth) {
      return;
    }

    const reqId = nextRequestId();
    requestIdRef.current = reqId;
    setIsLoading(true);

    const data = {
      namespace,
      deviceType: 'camera',
      timeRequest: Date.now(),
      page: pagination?.page - 1,
      size: pagination?.size,
    };

    // beeXLogger.debug('LivePage - LIST_ALL_DEVICE_BY_PAGE - body', data);

    const dataObj = {
      appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
      requestId: reqId,
      body: JSON.stringify(data),
    };

    dispatch(socketEmitEvent(dataObj));
  }, [isAuth, namespace, selectedGroupId, pagination?.page, pagination?.size]);

  useEffect(() => {
    if (
      selectedGroupId === RECENT_GROUP_ID ||
      selectedGroupId === ROOT_GROUP_ID ||
      selectedGroupId === CUSTOM_GROUP_ID ||
      !isAuth
    ) {
      return;
    }

    const reqId = nextRequestId();
    requestIdRef.current = reqId;
    setIsLoading(true);

    const dataBody = {
      namespace,
      deviceGroupId: selectedGroupId,
      timeRequest: Date.now(),
    };
    // beeXLogger.debug('LivePage - LIST_DEVICE_BY_DEVICE_GROUP_ID - dataBody', dataBody);

    const dataObj = {
      appServiceType: SERVICE.LIST_DEVICE_BY_DEVICE_GROUP_ID,
      requestId: reqId,
      body: JSON.stringify(dataBody),
    };

    dispatch(socketEmitEvent(dataObj));
  }, [selectedGroupId, isAuth, namespace]);

  const cameraDimensions = useMemo(() => {
    const { grid } = pagination;
    const { width: containerWidth, height: containerHeight } = dimensions || {};
    return {
      width: containerWidth / grid?.[0] - REDUCE_DIMENSIONS,
      height: containerHeight / grid?.[1] - REDUCE_DIMENSIONS,
    };
  }, [dimensions, pagination?.grid]);

  const requestGetSipAccount = () => {
    let data = {
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.REQUEST_MAKE_CALL_OUT,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  useEffect(() => {
    if (namespace) {
      requestGetSipAccount();
    }
  }, [namespace]);

  const onZoomState = (camera) => {
    let parsedSubSources = [];
    try {
      if (camera?.subSources) {
        parsedSubSources =
          typeof camera.subSources === 'string'
            ? JSON.parse(camera.subSources)
            : camera.subSources;
      }
    } catch (e) {
      console.error(e);
    }

    const subsourceZoomStates =
      parsedSubSources?.map((item) => ({
        resolution: item.resolution,
        zoomState: item.zoomState,
        codec: item.codec || null,
      })) ?? [];

    const defaultZoomStates =
      camera.zoomState !== undefined
        ? [
          {
            zoomState: camera.zoomState,
            resolution: camera.resolution,
            codec: camera.codec || null,
          },
        ]
        : [];

    const dataZoomStates = Array.from(
      new Map(
        [...defaultZoomStates, ...subsourceZoomStates].map((item) => [
          item.resolution,
          item,
        ]),
      ).values(),
    ).sort((a, b) => a.zoomState - b.zoomState);

    const defaultItem = dataZoomStates[0];

    return {
      dataZoomStates: dataZoomStates,
      zoomState: defaultItem?.zoomState,
      resolution: defaultItem?.resolution,
      codec: defaultItem?.codec || null,
    };
  };

  const handleSwitchPage = (timeSeconds) => {
    setAutoSwitchPageSeconds(timeSeconds);
    dispatch(updateRecoveryLivePage({ autoSwitchPageSeconds: timeSeconds }));
  };

  useEffect(() => {
    if (
      recoveryAutoSwitchPageSeconds &&
      recoveryAutoSwitchPageSeconds !== autoSwitchPageSeconds
    ) {
      setAutoSwitchPageSeconds(recoveryAutoSwitchPageSeconds);
    }
  }, [recoveryAutoSwitchPageSeconds]);

  useEffect(() => {
    if (autoSwitchPageSeconds > 0) {
      const interval = setInterval(() => {
        setPagination((state) => {
          // beeXLogger.debug('LivePage - autoSwitchPageSeconds - state.page: ', state.page);
          // beeXLogger.debug('LivePage - autoSwitchPageSeconds - state?.totalPage: ', state?.totalPage);
          const nextPage =
            state.page + 1 > state?.totalPage ? 1 : state.page + 1;
          // beeXLogger.debug('LivePage - autoSwitchPageSeconds - nextPage: ', nextPage);

          if (fullscreenCameraSerial) {
            setPendingPage((prev) => (prev >= nextPage ? prev + 1 : nextPage));
            return state;
          }

          // beeXLogger.debug('LivePage - autoSwitchPageSeconds - Math.min(nextPage, state.totalPage): ', Math.min(nextPage, state.totalPage));
          return {
            ...state,
            page: Math.min(nextPage, state.totalPage),
          };
        });
      }, autoSwitchPageSeconds * 1000);
      return () => clearInterval(interval);
    }
  }, [autoSwitchPageSeconds, pagination?.total, fullscreenCameraSerial]);

  useEffect(() => {
    // beeXLogger.debug('LivePage - pendingPage: ', pendingPage);
    if (!fullscreenCameraSerial && pendingPage !== null) {
      setPagination((state) => ({
        ...state,
        page: pendingPage,
      }));
      setPendingPage(null);
    }
  }, [fullscreenCameraSerial, pendingPage]);

  const onPageChange = useCallback(
    (page) => {
      const newPagination = {
        ...pagination,
        page,
      };
      setPagination(pagination);
      dispatch(updateRecoveryLivePage({ pagination: newPagination }));
    },
    [dispatch, pagination],
  );

  const viewModes = [
    {
      size: 4,
      grid: [2, 2],
      quality: ZOOM_STATE.THREE,
      iconOn: IconSize4On,
      iconOff: IconSize4Off,
      label: '2x2',
    },
    {
      size: 9,
      grid: [3, 3],
      quality: ZOOM_STATE.THREE,
      iconOn: IconSize9On,
      iconOff: IconSize9Off,
      label: '3x3',
    },
    {
      size: 16,
      grid: [4, 4],
      quality: ZOOM_STATE.TWO,
      iconOn: IconSize16On,
      iconOff: IconSize16Off,
      label: '4x4',
    },
    {
      size: 30,
      grid: [6, 5],
      quality: ZOOM_STATE.ONE,
      iconOn: IconSize65On,
      iconOff: IconSize65Off,
      label: '6x5',
      className: 'per6',
    },
    {
      size: 36,
      grid: [6, 6],
      quality: ZOOM_STATE.ONE,
      iconOn: IconSize66On,
      iconOff: IconSize66Off,
      label: '6x6',
      className: 'per6',
    },
  ];

  const handleModeChange = useCallback(
    (mode) => {
      const nextPagination = {
        ...pagination,
        size: mode.size,
        page: 1,
        quality: mode.quality,
        grid: mode.grid,
        totalPage: Math.ceil(total / mode.size),
      };

      const isSameMode =
        pagination?.size === mode.size &&
        pagination?.quality === mode.quality &&
        pagination?.grid?.[0] === mode.grid?.[0] &&
        pagination?.grid?.[1] === mode.grid?.[1];

      if (isSameMode) {
        return;
      }

      setPagination(nextPagination);
      dispatch(
        updateRecoveryLivePage({
          pagination: nextPagination,
        }),
      );
    },
    [dispatch, pagination, total],
  );

  useEffect(() => {
    if (!recoveryPagination) {
      return;
    }

    setPagination((state) => {
      const isSamePagination =
        recoveryPagination.page === state.page &&
        recoveryPagination.size === state.size &&
        recoveryPagination.quality === state.quality &&
        recoveryPagination.grid?.[0] === state.grid?.[0] &&
        recoveryPagination.grid?.[1] === state.grid?.[1];

      if (isSamePagination) {
        return state;
      }

      return {
        ...state,
        ...recoveryPagination,
      };
    });
  }, [recoveryPagination]);

  const modeButtonsComponent = (pageSize) => (
    <div className="mode-button">
      <Tooltip placement="bottom" title={t('Toggle full screen view')}>
        <div onClick={handleFullScreen.enter} className="mode">
          <img src={IconFullScreen} alt="mode" />
        </div>
      </Tooltip>

      {viewModes.map((mode) => (
        <Tooltip
          key={mode.size}
          placement="bottom"
          title={t(`Toggle to ${mode.label} view mode`)}
        >
          <div
            onClick={() => handleModeChange(mode)}
            className={`mode ${mode.className || ''}`}
          >
            <img
              src={pageSize === mode.size ? mode.iconOn : mode.iconOff}
              alt="mode"
            />
          </div>
        </Tooltip>
      ))}
      <Select
        className="header-camera-select"
        placeholder={t('Interval')}
        value={autoSwitchPageSeconds}
        onChange={handleSwitchPage}
      >
        <Option value={0}>{t('Off autoload')}</Option>
        <Option value={120}>2 {t('minutes')}</Option>
        <Option value={300}>5 {t('minutes')}</Option>
        <Option value={600}>10 {t('minutes')}</Option>
        <Option value={1800}>30 {t('minutes')}</Option>
      </Select>
      <div
        onClick={() => {
          setIsViewAll((prevState) => !prevState);
        }}
      >
        <img src={isViewAll ? AutoPlayOn : AutoPlayOff} alt="auto-play" />
      </div>
      <span
        style={{
          alignSelf: 'center',
          display: 'inline-block',
          marginRight: '16px',
          marginLeft: '4px',
        }}
      >
        {t('Auto play')}
      </span>
      <div
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        onClick={() => {
          const showModalEnableSmartMode = localStorage.getItem(
            'showModalEnableSmartMode',
          );
          if (
            showModalEnableSmartMode === null ||
            !!Number(showModalEnableSmartMode)
          ) {
            setModalEnableSmartModeVisible(true);
          } else {
            dispatch(toggleSmartMode(true));
            handleFullScreen.enter();
          }
        }}
      >
        <img width={45} src={AIView} alt="ai-view" />
      </div>
    </div>
  );

  const [listSerialEvent, setListSerialEvent] = useState([]);
  const getEventBeforeCurrent = async (fromTime, toTime) => {
    const token = storageService.getInternalStorageByKey(
      SYSTEM.DECODED_ACCESS_TOKEN,
    );
    const query = {
      token,
      dataHeader: { namespace },
      dataQuery: {
        fromTime: fromTime,
        toTime: toTime,
        customerNamespace: namespace,
        isDownload: 0,
        limit: 1000,
        offset: 0,
      },
    };
    Promise.all([
      getVirtualWall(query), //tường rào ảo
      getWeaponDetection(query), // hung khí
      getHistoryTrackingEvents(query), // theo dõi
      getEventsByPersonId({
        token,
        dataHeader: {
          namespace: '',
          tenantId: namespace,
        },
        dataQuery: {
          fromTime: fromTime,
          toTime: toTime,
          limit: 1000,
          offset: 0,
          personId: '',
        },
      }), // Nhận diện
      getSecurityIdentifications(query), // xâm nhập
    ]).then((values) => {
      const serialNameSet = new Set();

      values[0].data.records.forEach((record) => {
        if (record?.serial) {
          serialNameSet.add(record.serial);
        }
      });
      values[1].data.records.forEach((record) => {
        if (record?.serial) {
          serialNameSet.add(record.serial);
        }
      });
      values[2].data.records.forEach((record) => {
        if (record?.serial) {
          serialNameSet.add(record.serial);
        }
      });
      values[3].data.cdrs.forEach((record) => {
        if (record?.serial) {
          serialNameSet.add(record.serial);
        }
      });
      values[4].data.records.forEach((record) => {
        if (record?.serial) {
          serialNameSet.add(record.serial);
        }
      });

      const serialName = Array.from(serialNameSet);
      setListSerialEvent(serialName);
    });
  };

  useEffect(() => {
    // event để test
    // getEventBeforeCurrent(1720630800, 1720717199);
    if (enabledSmartMode) {
      getEventBeforeCurrent(
        moment().startOf('day').valueOf(),
        moment().endOf('day').valueOf(),
      );
    }
  }, [enabledSmartMode]);

  const onSelectAlert = (alert) => {
    setSelectCamera(alert);
    dispatch(updateRecoveryLivePage({ selectedCamera: alert }));
  };

  const timer = useRef({});

  const toggleClass = (serial) => {
    // beeXLogger.debug('LivePage - TOGGLE CLASS', serial);
    const camera = document.querySelector(`[data-serial="${serial}"]`);
    if (camera) {
      // beeXLogger.debug('LivePage - CAMERA', camera);
      const isAlerting = camera.classList.contains('alerting');
      if (!isAlerting) {
        camera.classList.add('alerting');
      } else {
        if (timer.current[serial]) {
          clearTimeout(timer.current[serial]); //cancel the previous timer.
          timer.current[serial] = null;
        }
      }
      timer.current[serial] = setTimeout(() => {
        camera.classList.remove('alerting');
      }, 5000);
    }
  };

  const newestActiveCamera = detectionAlerts?.[0];

  useEffect(() => {
    if (newestActiveCamera) {
      toggleClass(newestActiveCamera.serial);
    }
  }, [newestActiveCamera]);

  useEffect(() => {
    localStorage.setItem('auto_play', isViewAll ? 'on' : 'off');
  }, [isViewAll]);

  const { gateways } = useGateways(camerasToDisplay.map((cam) => cam.serial));

  const addCameraToRecent = (camera) => {
    setRecentItems((prev) => {
      const newItems = prev.filter(
        (item) => item.type !== 'camera' || item.data.serial !== camera.serial,
      );

      return [{ data: camera, type: 'camera' }, ...newItems];
    });
    // openMessage(NOTIFIES.INFO, 'Camera added to recent');
  };

  const removeCameraFromRecent = (serial) => {
    setRecentItems((prev) => {
      return prev.filter(
        (item) => item.type !== 'camera' || item.data.serial !== serial,
      );
    });
  };

  const getIsCameraPinned = (serial) => {
    return recentItems.some(
      (item) => item.type === 'camera' && item.data.serial === serial,
    );
  };

  const onPinCamera = (cam, pinned) => {
    if (pinned) {
      addCameraToRecent(cam);

      return;
    }

    Modal.confirm({
      title: 'Unpin camera',
      content: 'Are you sure you want to unpin this camera?',
      onOk: () => {
        removeCameraFromRecent(cam.serial);
      },
    });
  };

  const [activeTab, setActiveTab] = useState('list');

  useEffect(() => {
    if (sidebarMode && sidebarMode !== activeTab) {
      setActiveTab(sidebarMode);
    }
  }, [sidebarMode]);

  const onTabChange = (key) => {
    if (key === 'list') {
      setCustomCamera(null);
    }

    setActiveTab(key);
    dispatch(
      updateRecoveryLivePage({
        sidebarMode: key,
      }),
    );
  };

  const setAsCustomCamera = (camera) => {
    if (!camera) {
      setCustomCamera(null);

      return;
    }

    setCustomCamera(camera);
    setSelectCamera(camera);
    dispatch(updateRecoveryLivePage({ selectedCamera: camera }));
  };

  ////////////////////////////////
  /////// ALERT CAMERAS /////////
  ////////////////////////////////

  // store camera at index i which replaces `camerasToDisplay[i]`
  const [alertCams, setAlertCams] = useState([]);
  const alertTimeBySerial = useRef({});

  const resetAlertCams = () => {
    setAlertCams([]);
    alertTimeBySerial.current = {};
  };

  const mergedCameras = useMemo(() => {
    return mergeCameras(camerasToDisplay, alertCams);
  }, [camerasToDisplay, alertCams]);

  useEffect(() => {
    if (!newestActiveCamera || !enabledSmartMode) {
      return;
    }

    alertTimeBySerial.current[newestActiveCamera.serial] = Date.now();

    const isExist = mergedCameras.some(
      (cam) => cam.serial === newestActiveCamera.serial,
    );

    if (isExist) {
      return;
    }

    const requestId = nextRequestId();

    const camRecord = {
      serial: newestActiveCamera.serial,
      requestId,
      isMock: true,
    };

    // get camera detail
    setTimeout(() => {
      const payload = {
        appServiceType: SERVICE.GET_DEVICE_CONTACT_INFO,
        requestId,
        body: JSON.stringify({
          serial: newestActiveCamera.serial,
          namespace,
        }),
      };

      dispatch(socketEmitEvent(payload));
    });

    const hasSpace = mergedCameras.length < pagination?.size;

    // if page is not full, simply add it to the list
    if (hasSpace) {
      setAlertCams((prev) => {
        const newCams = [...prev];
        newCams[mergedCameras.length] = camRecord;

        return newCams;
      });

      return;
    }

    // if page is full, replace it with least alerted camera
    const leastAlertedCamera = mergedCameras.reduce((min, cam) => {
      // if min is not alerted, return min
      if (!alertTimeBySerial.current[min.serial]) {
        return min;
      }

      // if cam is not alerted, return cam
      if (!alertTimeBySerial.current[cam.serial]) {
        return cam;
      }

      // take the least alerted camera
      return alertTimeBySerial.current[cam.serial] <
        alertTimeBySerial.current[min.serial]
        ? cam
        : min;
    }, mergedCameras[0]);
    const indexOfLeastAlertedCamera = mergedCameras.findIndex(
      (cam) => cam.serial === leastAlertedCamera.serial,
    );

    setAlertCams((prev) => {
      const newAlertCams = [...prev];
      newAlertCams[indexOfLeastAlertedCamera] = camRecord;

      return newAlertCams;
    });
  }, [newestActiveCamera, enabledSmartMode, mergedCameras, pagination?.size]);

  useEffect(() => {
    if (!deviceContactInfo) {
      return;
    }

    let modified = false;

    setAlertCams((prev) => {
      // beeXLogger.debug('LivePage - XYZ2');
      const needsModify = prev.some(
        (cam) =>
          cam.serial === deviceContactInfo.serial &&
          cam.isMock &&
          cam.requestId === deviceContactInfo.requestId,
      );

      if (!needsModify) {
        return prev;
      }

      modified = true;

      return prev.map((cam) => {
        if (
          cam.serial === deviceContactInfo.serial &&
          cam.requestId === deviceContactInfo.requestId
        ) {
          return deviceContactInfo;
        }

        return cam;
      });
    });

    setTimeout(() => {
      if (modified) {
        toggleClass(deviceContactInfo.serial);
      }
    }, 500);
  }, [deviceContactInfo]);

  const finalCamerasToDisplay = useMemo(() => {
    if (enabledSmartMode) {
      return mergeCameras(camerasToDisplay, alertCams);
    }

    return camerasToDisplay;
  }, [camerasToDisplay, alertCams, enabledSmartMode]);

  // // beeXLogger.debug('LivePage - DETECTION ALERTS', detectionAlerts);
  // // beeXLogger.debug('LivePage - ALERT CAM', alertCams);

  const onSelectGroup = (group) => {
    setSelectedGroup(group);
    dispatch(updateRecoveryLivePage({ selectedGroup: group }));
  };

  useEffect(() => {
    if (recoveryGroup && recoveryGroup.id !== selectedGroupId) {
      setSelectedGroup(recoveryGroup);
    }
  }, [recoveryGroup, selectedGroupId]);

  useEffect(() => {
    return () => {
      dispatch(resetRecoveryLivePage());
    };
  }, []);

  const onSearch = (value) => {
    setSearchResult(value);
  };

  const onSelectCamera = (camera) => {
    setSelectCamera(camera);
    dispatch(updateRecoveryLivePage({ selectedCamera: camera }));
  };

  useEffect(() => {
    if (
      recoverySelectedCamera &&
      recoverySelectedCamera.serial !== selectCamera?.serial
    ) {
      setSelectCamera(recoverySelectedCamera);
    }
  }, [recoverySelectedCamera, selectCamera]);

  return (
    <div className="camera-component">
      <Modal
        title={t('Enable smart mode?')}
        visible={modalEnableSmartModeVisible}
        onCancel={() => setModalEnableSmartModeVisible(false)}
        footer={[
          <Button onClick={() => setModalEnableSmartModeVisible(false)}>
            {t('Cancel')}
          </Button>,
          <Button type="primary" onClick={() => history.push('/service')}>
            Go to service page
          </Button>,
          <Button
            type="primary"
            onClick={() => {
              dispatch(toggleSmartMode(true));
              handleFullScreen.enter();
              setModalEnableSmartModeVisible(false);
              const show = !showModalEnableSmartMode.current;
              localStorage.setItem(
                'showModalEnableSmartMode',
                show ? '1' : '0',
              );
            }}
          >
            {t('Continue')}
          </Button>,
        ]}
      >
        <div>{t('To activate smart mode')}</div>
        <ul>
          <li>
            {t('Someone has entered the restricted area - DETECT_OBJECT')}
          </li>
          <li>{t('Someone appeared - DETECT_PERSON')}</li>
          <li>{t('Someone is carrying a weapon - DETECT_WEAPON')}</li>
          <li>{t('Fire smoke detection - DETECT_FIRE')}</li>
          <li>
            {t('There is an object crossing the fence - DETECT_VIRTUAL_WALL')}
          </li>
          <li>{t("Recognize object's face - RECOGNITION_FACE(529)")}</li>
        </ul>
        <Checkbox
          defaultChecked={false}
          onChange={(event) => {
            showModalEnableSmartMode.current = event.target.checked;
          }}
        >
          {t('Do not show this again')}
        </Checkbox>
      </Modal>
      <Layout>
        <Sider width={pagination?.size === 36 ? 340 : 324}>
          <div className="live-tab-content">
            <Tabs activeKey={activeTab} onChange={onTabChange}>
              <Tabs.TabPane
                tab={
                  <span>
                    <UnorderedListOutlined /> List
                  </span>
                }
                key="list"
              >
                <ListCamera
                  namespace={namespace}
                  cameras={allCameras}
                  currentPage={pagination?.page}
                  pageSize={pagination?.size}
                  total={total}
                  onPageChange={onPageChange}
                  onSearch={onSearch}
                  LivePage-
                  isLoading={isLoading}
                  selectedGroup={selectedGroup}
                  onSelectGroup={onSelectGroup}
                  getIsCameraPinned={getIsCameraPinned}
                  onPinCamera={onPinCamera}
                  selectedSerial={selectCamera?.serial}
                  onSelectCamera={onSelectCamera}
                />
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={
                  <span>
                    <ApartmentOutlined /> Tree
                  </span>
                }
                key="tree"
              >
                <LiveTree
                  namespace={namespace}
                  onSelect={onSelectGroup}
                  selectedGroup={selectedGroup}
                  onSelectCamera={onSelectCamera}
                  selectedCamera={selectCamera}
                  getIsCameraPinned={getIsCameraPinned}
                  onPinCamera={onPinCamera}
                  setAsCustomCamera={setAsCustomCamera}
                  customCamera={customCamera}
                />
              </Tabs.TabPane>
            </Tabs>
          </div>
        </Sider>
        <Layout>
          <div
            className="header-camera-component"
            style={{
              width: `calc(100% - ${pagination?.size === 36 ? 360 : 332}px)`,
            }}
          >
            {modeButtonsComponent(pagination?.size)}

            <div className="pagination">
              <Pagination
                current={pagination?.page}
                onChange={onPageChange}
                total={total}
                pageSize={pagination?.size}
                showSizeChanger={false}
              />
            </div>
          </div>
          <div className="main-camera-component">
            <FullScreen
              handle={handleFullScreen}
              onChange={(isFullScreen) => {
                setFullScreen(isFullScreen);
                //handle reset layout => fix break layout after toggle fullscreen mode
                setPagination((prevState) => ({
                  ...prevState,
                  grid: prevState.grid,
                }));
                if (!isFullScreen) {
                  dispatch(toggleSmartMode(false));
                  if (enabledSmartMode) {
                    setSelectCamera(null);
                    dispatch(updateRecoveryLivePage({ selectedCamera: null }));
                    dispatch(clearAlert([]));
                    resetAlertCams();
                  }
                }
              }}
            >
              {gateways && !finalLoading ? (
                <>
                  <Row
                    ref={ref}
                    onDoubleClick={() => {
                      handleFullScreen.exit();
                      setFullScreen(false);
                      dispatch(toggleSmartMode(false));
                      dispatch(clearAlert([]));
                      resetAlertCams();
                    }}
                    gutter={[4, 4]}
                    className={clsx('main-live-page', {
                      fullscreen: handleFullScreen.active,
                      noneFullScreen: !handleFullScreen.active,
                    })}
                    id="main-live-page"
                    style={{
                      padding: isFullscreen && enabledSmartMode ? '8px' : '',
                      display: 'grid',
                      gridTemplateColumns: `repeat(${pagination?.grid?.[0]}, 1fr)`,
                      gridTemplateRows: `repeat(${pagination?.grid?.[1]}, 1fr)`,
                      width:
                        isFullscreen && !enabledSmartMode
                          ? '100%'
                          : `calc(100% - ${pagination?.size === 36 ? 350 : 332
                          }px)`,
                      height: `calc(100vh - 108px)`,
                    }}
                  >
                    {finalCamerasToDisplay?.length > 0 ? (
                      finalCamerasToDisplay.map((camera) => (
                        <div
                          key={camera.serial}
                          data-serial={camera.serial}
                          style={{
                            height: cameraDimensions.height,
                            width: '100%',
                            padding: '4px',
                          }}
                          className={classNames({
                            'camera-container': true,
                            fullscreen: isFullscreen,
                            selected:
                              selectCamera &&
                              selectCamera.serial &&
                              camera.serial === selectCamera.serial,
                            'show-border': listSerialEvent.includes(
                              camera.serial,
                            ),
                          })}
                        >
                          {camera?.typeCamera === CAMERA_TYPE.MILESTONE ? (
                            <MilestoneVideoStreamComponent
                              tabActive="live"
                              key={camera.serial}
                              allScreen={handleFullScreen.active}
                              zoomState={onZoomState?.(camera)}
                              name={camera.name}
                              typeCamera={camera.typeCamera}
                              resolution={camera.resolution}
                              serviceId={VIEW_STREAM_SERVICE_EXTEND.normal}
                              state={camera.state}
                              serial={camera.serial}
                              gatewaySerial={camera.gatewaySerial}
                              thumbnail={camera.thumbnail}
                              isInternal={
                                gateways &&
                                gateways.some(
                                  (gateway) =>
                                    gateway.serial === camera.gatewaySerial,
                                )
                              }
                              permission={camera.permission}
                              isAllowStreaming={camera.isAllowStreaming}
                              isViewAll={isViewAll}
                              onlyShowThumbnail={false}
                              onFullscreenChange={(isFullscreen) => {
                                setFullscreenCameraSerial(
                                  isFullscreen ? camera.serial : null,
                                );
                              }}
                            />
                          ) : (
                            <ViewStreamComponent
                              key={camera.serial}
                              allScreen={handleFullScreen.active}
                              isViewAll={isViewAll}
                              zoomState={onZoomState(camera)}
                              name={camera.name}
                              typeCamera={camera.typeCamera}
                              resolution={camera.resolution}
                              serviceId={VIEW_STREAM_SERVICE_EXTEND.normal}
                              state={camera.state}
                              serial={camera.serial}
                              gatewaySerial={camera.gatewaySerial}
                              thumbnail={camera.thumbnail}
                              codec={camera.codec}
                              subSources={camera.subSources}
                              isInternal={
                                gateways &&
                                gateways.some(
                                  (gateway) =>
                                    gateway.serial === camera.gatewaySerial,
                                )
                              }
                              permission={camera.permission}
                              isAllowStreaming={camera.isAllowStreaming}
                              gridMode={
                                pagination?.size === 4
                                  ? 'is4Mode'
                                  : pagination?.size === 9
                                    ? 'is9Mode'
                                    : pagination?.size === 16
                                      ? 'is16Mode'
                                      : pagination?.size === 30
                                        ? 'is30Mode'
                                        : pagination?.size === 36
                                          ? 'is36Mode'
                                          : ''
                              }
                              onFullscreenChange={(isFullscreen) => {
                                setFullscreenCameraSerial(
                                  isFullscreen ? camera.serial : null,
                                );
                              }}
                            />
                          )}
                        </div>
                      ))
                    ) : (
                      <Empty
                        style={{ margin: 80 }}
                        image={IconCameraEmpty}
                        imageStyle={{
                          height: 100,
                        }}
                        description={<span>{t('No cameras to view!')}</span>}
                      />
                    )}
                  </Row>
                  <>
                    {isFullscreen && enabledSmartMode && (
                      <AlertBox
                        events={detectionAlerts}
                        pagination={pagination}
                        onSelect={onSelectAlert}
                        setPagination={setPagination}
                        gateways={gateways}
                        data={finalCamerasToDisplay}
                      />
                    )}

                    {isFullscreen && !enabledSmartMode && (
                      <div
                        style={{
                          position: 'fixed',
                          right: '-10px',
                          bottom: '-15px',
                          width: '50px',
                          height: '50px',
                          cursor: 'pointer',
                        }}
                      >
                        <div
                          style={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          onClick={() => {
                            dispatch(toggleSmartMode(true));
                          }}
                        >
                          <img src={AIView} alt="ai-view" />
                        </div>
                      </div>
                    )}
                  </>
                </>
              ) : (
                <Spinner />
              )}
            </FullScreen>
          </div>

          <DialPad
            open={dialPad?.show}
            onClose={() => {
              dispatch(
                changeDialPadData({
                  show: false,
                  phone: '',
                }),
              );
            }}
            accountSip={sipAccount || {}}
            calledPhone={dialPad?.phone || ''}
          />
        </Layout>
      </Layout>
    </div>
  );
};

export default LivePage;
